import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import moment from "moment"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import * as userSlice from "../store/user"
import * as userApis from "../utilities/apis/user"
import * as orderApis from "../utilities/apis/order"
import { isDeal, isProduct, url } from "../utilities/enumerations/constants"

const Checkout = () => {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleCart = async (item) => {
    dispatch(cartSlice.addToCart(item))
  }

  const handleDecrement = async (item) => {
    dispatch(cartSlice.handleDecrement(item.slug))
  }

  const handleIncrement = async (item) => {
    if (cartState.productsById[item.slug] >= 5) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleIncrement(item.slug))
  }

  const handleSubmit = async (e) => {
    try {
      setLoading(true)
      e.preventDefault()

      // const shipDatetime = moment(`${e.target.date.value} ${e.target.time.value}`)
      const products = cartState.cart.filter((item) => !item.products).map((item) => ({
        cost: item.cost,
        price: item.price,
        quantity: cartState.productsById[item.slug],
        product_id: item.id
      }))
      const orderDeals = cartState.cart.filter((item) => item.products)
      const deals = []

      orderDeals.forEach((item) => item.products.map((product) => {
        deals.push({
          cost: product.cost,
          price: product.price,
          quantity: cartState.productsById[item.slug],
          deal_cost: item.cost,
          deal_price: item.price,
          deal_discount: item.discount,
          deal_quantity: item.cart || 0,
          swap: product.swap || 0,
          product_id: product.id,
          deal_id: item.id
        })
      }))
      const lineitems = products.concat(deals)

      const payload = {
        zone: {
          name: "N/A"
        },
        customer: {
          mobile: e.target.mobile.value,
          address: e.target.address.value
        },
        order: {
          discount: 0,
          customer_note: e.target.note.value,
          // ship_datetime: shipDatetime.format("YYYY-MM-DD HH:mm"),
          ship_datetime: moment().add(2, 'days').format("YYYY-MM-DD HH:mm"),
          total: cartState.cart.reduce((p, c) => p += c.price * cartState.productsById[c.slug], 0),
          cost: cartState.cart.reduce((p, c) => p += c.cost * cartState.productsById[c.slug], 0),
          commission: 0
        },
        order_lineitems: lineitems
      }

      const response = await orderApis.checkout(payload)
      if (!response.status) throw new Error(response.message)

      dispatch(cartSlice.emptyCart())
      alert("Order placed")
      navigate("/")
    } catch (error) {
      alert(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <div className="container">
        <section className="py-3">
          <p className="lead text-body-emphasis fw-bold">Checkout</p>
          <div className="row g-3">
            <div className="col-md-8">
              <div className="bg-secondary border border-bottom-0 rounded-top-4 p-4">
                <div className="d-flex flex-column gap-3">
                  {cartState.cart.map((item) => {
                    let src = "/upload.png"
                    if (item.thumbnail) src = item.thumbnail
                    // if (item.thumbnail_url) src = item.thumbnail_url.replace("public", url)

                    return (
                      <div className="d-flex justify-content-between align-items-center gap-3">
                        <img src={src} alt={item.title} className="thumbnail-img rounded-3" width={48} height={48} />
                        <div className="flex-grow-1">
                          <p className="text-body-emphasis fw-bold m-0">{item.title}</p>
                          <p className="small text-muted fw-semibold m-0">Rs. {(item.price - (item.discount || 0)).toFixed(2)}</p>
                        </div>
                        <div className="d-flex gap-3 justify-content-between align-items-center">
                          <button type="button" className="btn btn-sm btn-light-theme rounded-3 flex-grow-1" onClick={() => handleDecrement(item)}><i className="bi bi-dash-lg"></i></button>
                          <p className="flex-grow-1 small text-muted text-center fw-bold m-0">{cartState.productsById[item.slug]}</p>
                          <button type="button" className="btn btn-sm btn-light-theme rounded-3 flex-grow-1" onClick={() => handleIncrement(item)}><i className="bi bi-plus-lg"></i></button>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="bg-secondary border border-bottom-0 p-4 py-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <p className="text-body-tertiary fw-bold m-0">Sub Total</p>
                  <p className="text-body-tertiary fw-bold m-0">{cartState.cart.reduce((p, c) => p += c.price * cartState.productsById[c.slug], 0).toFixed(2)}</p>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <p className="text-body-tertiary fw-bold m-0">Discount</p>
                  <p className="text-body-tertiary fw-bold m-0">{cartState.cart.reduce((p, c) => p += c.discount * cartState.productsById[c.slug] || 0, 0).toFixed(2)}</p>
                </div>
              </div>
              <div className="bg-light border rounded-bottom-4 p-4 py-3">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="text-body-emphasis fw-bold m-0">Total</p>
                  <p className="text-body-emphasis fw-bold m-0">{(cartState.cart.reduce((p, c) => p += c.price * cartState.productsById[c.slug], 0) - cartState.cart.reduce((p, c) => p += c.discount * cartState.productsById[c.slug] || 0, 0)).toFixed(2)}</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <form method="post" onSubmit={handleSubmit}>
                <div className="d-flex flex-column gap-3">
                  <div class="card rounded-4 shadow-none">
                    <div class="card-body py-4">
                      <div class="mb-3">
                        <label for="mobile" className="form-label">Mobile No</label>
                        <input type="text" name="mobile" class="form-control rounded-3" id="mobile" required />
                      </div>
                      <div class="mb-3">
                        <label for="address" className="form-label">Address</label>
                        <input type="text" name="address" class="form-control rounded-3" id="address" required />
                      </div>
                      {/* <div class="mb-3">
                        <label for="date" className="form-label">Ship Date</label>
                        <input type="date" name="date" class="form-control rounded-3" id="date" required />
                      </div>
                      <div class="mb-3">
                        <label for="time" className="form-label">Ship Time</label>
                        <input type="time" name="time" class="form-control rounded-3" id="time" required />
                      </div> */}
                      <div>
                        <label for="note" className="form-label">Note</label>
                        <textarea name="note" class="form-control rounded-3" id="note" rows={4}></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="alert alert-danger rounded-4 m-0">
                    <p class="fst-italic">* Please note if you want to change the products according to your need you can mention it in the notes, additional charges may apply</p>
                    <p class="text-end fst-italic m-0">اگر آپ اپنی ضرورت کے مطابق مصنوعات کو تبدیل کرنا چاہتے ہیں تو آپ اس کا ذکر نوٹ میں کرسکتے ہیں، اضافی چارجز لاگو ہوسکتے ہیں</p>
                  </div>

                  <button type="submit" class="btn btn-lg btn-theme rounded-4 w-100">Place Order</button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </GuestLayout>
  )
}

export default Checkout
